/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const UseAbility = require('../UseAbility');

const Q_enemy_adjacent = function (
  moveToEnemyNode,
  aggroNode,
  actor,
  battleState
) {
  const node = new YesNoNode(actor, battleState);

  node.branches[node.NO] = moveToEnemyNode;

  if (BattleCalc.getEquippedAbility(actor, 'tussle')) {
    node.branches[node.YES] = new UseAbility(actor, 'tussle');
  } else {
    node.branches[node.YES] = aggroNode;
  }

  node.yesNoEvalFunction = function (target) {
    return BattleCalc.adjacent(this.actor, target);
  };

  return node;
};
module.exports = Q_enemy_adjacent;
